export default "__VITE_ASSET__24e4b115__"